import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Aos from "aos";

import HomePage from "./pages/HomePage/HomePage";
import Signup from "./pages/SignupPage/Signup";
import GlobalStyle from "./globalStyles";
import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";
import Booking from "./pages/Booking/Booking";
import { Toaster } from "react-hot-toast";
import AuthModal from "./components/AuthModal/AuthModal";
import Dashboard from "./components/Dashboard/Dashboard";
import Orders from "./components/Dashboard/BookingList";
import Password from "./components/Dashboard/Password";
import UpdateProfile from "./components/Dashboard/UpdateProfile";
import BookingList from "./components/Dashboard/BookingList";
import BookingDetail from "./components/Dashboard/BookingDetail";
import BookingModify from "./components/Dashboard/BookingModify";
import ResetPasswordForm from "./components/AuthModal/ResetPassword";
import NotFound from "./pages/NotFound";
import PrivateRoute from "./PrivateRoute";
import SessionExpiredModal from "./components/SectionExpiredModal/SectionExpiredModal";

function App() {
  useEffect(() => {
    Aos.init();
  }, []);

  return (
    <Router>
      <GlobalStyle />
      <Toaster position="top-center" duration="4000" />
      <Navbar />
      <AuthModal />
      <SessionExpiredModal />
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<HomePage />} />
        <Route path="/sign-up" element={<Signup />} />
        <Route path="/reset-password/:token" element={<ResetPasswordForm />} />
        <Route path="*" element={<NotFound />} />
        {/* Private Routes */}
        {/* <Route element={<PrivateRoute />}> */}
        <Route path="/booking/:tag" element={<Booking />} />

        {/* Dashboard and its sub-routes */}
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/dashboard/listofbooking" element={<BookingList />} />
        <Route path="/bookingdetail/:id" element={<BookingDetail />} />
        <Route path="/reschedule/:id" element={<BookingModify />} />

        <Route path="/dashboard/profile" element={<UpdateProfile />} />
        <Route path="/dashboard/password" element={<Password />} />
        {/* </Route> */}
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
